import React from 'react';
import './titles-footer.css'


const Titlefooter = (props) => {
    return ( 
        <h2 className='titless-footerr'>{props.title}</h2>
     );
}
 
export default Titlefooter;